import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  ArrowRightOnRectangleIcon,
  Bars3Icon,
  ChartBarIcon,
  CheckCircleIcon,
  Cog8ToothIcon,
  MagnifyingGlassIcon,
  UserIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { DecodedIdToken } from "firebase-admin/auth";
import Image from "next/image";
<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  strokeWidth={1.5}
  stroke="currentColor"
  className="w-6 h-6"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
  />
</svg>;

import Link from "next/link";
import { useRouter } from "next/router";
import { Fragment, useState } from "react";
import { classNames } from "../data/classnames";
import { MarketInfo } from "../pages/_app";
import { GavelIcon, StudioLogo } from "./Icons";

const navigationDefault = [
  { name: "Sales", href: "/sales", icon: GavelIcon },
  { name: "Clients", href: "/clients", icon: UserIcon },
  // { name: "Broadcast", href: "/broadcast", icon: MegaphoneIcon },
  { name: "Reports", href: "/reports", icon: ChartBarIcon },
];

const subnav = [{ name: "Settings", href: "/settings", icon: Cog8ToothIcon }];

export type TabName = "Sales" | "Clients" | "Broadcast" | "Reports";

export interface LayoutProps {
  children: React.ReactNode;
  activeTab: string;
  session?: DecodedIdToken;
  markets?: MarketInfo[];
  market?: MarketInfo;
  hideButtons?: boolean;
}

export default function Layout(props: LayoutProps) {
  let [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  let navigation = props.hideButtons ? [] : navigationDefault;

  let name = props.session?.name;
  let picture =
    props.session?.picture || require("../images/studio_logomark.png");
  let martlogo = props.market?.logo;

  let router = useRouter();
  let pathWithoutMarketId = props.market
    ? router.pathname.replace(`/[marketId]`, "")
    : router.pathname;
  let firstPathLevel = pathWithoutMarketId.split("/")[1] || "";

  return (
    <>
      <div className="flex h-full">
        <Transition.Root show={mobileMenuOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-40 lg:hidden"
            onClose={setMobileMenuOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white focus:outline-none">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 -mr-12 pt-4">
                      <button
                        type="button"
                        className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="pt-5 pb-4">
                    <div className="flex flex-shrink-0 items-center px-4">
                      <div className="h-8 w-auto">
                        <Link href={`/${props.market?.id || ""}`}>
                          <StudioLogo height={"2rem"} />
                        </Link>
                      </div>
                    </div>
                    <nav aria-label="Sidebar" className="mt-5">
                      <div className="space-y-1 px-2">
                        {navigation.map((item) => (
                          <Link
                            key={item.name}
                            href={`/${props.market?.id}${item.href}`}
                            className={classNames(
                              "group flex items-center rounded-md p-2 text-base font-medium hover:bg-gray-50 hover:text-gray-900",
                              item.name === props.activeTab
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-600 "
                            )}
                          >
                            <item.icon
                              className="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                              aria-hidden="true"
                            />
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    </nav>
                  </div>

                  <div className="pt-2 pb-2 border-t border-gray-200 ">
                    <nav aria-label="Sidebar Secondary" className="">
                      <div className="space-y-1 px-2">
                        {subnav.map((item) => (
                          <Link
                            key={item.name}
                            href={`/${props.market?.id}${item.href}`}
                            className={classNames(
                              "group flex items-center rounded-md p-2 text-base font-medium hover:bg-gray-50 hover:text-gray-900",
                              item.name === props.activeTab
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-600 "
                            )}
                          >
                            <item.icon
                              className="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500 "
                              aria-hidden="true"
                            />
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    </nav>
                  </div>

                  <div className="flex flex-shrink-0 border-t border-gray-200 p-4">
                    <div className="flex flex-col w-full">
                      {(props.markets || []).map((m, i) => (
                        <Link
                          key={m.id}
                          href={`/${m.id}/${firstPathLevel}`}
                          className={classNames(
                            "group block flex-shrink-0",
                            i > 0 ? "mt-4" : ""
                          )}
                        >
                          <div className="flex items-center">
                            <div>
                              {m.logo && (
                                <Image
                                  className="h-10 w-10 rounded-full mr-2"
                                  src={m.logo}
                                  width={40}
                                  height={40}
                                  alt={`${m.name} Logo`}
                                />
                              )}
                            </div>
                            <div className="ml-3 flex align-middle justify-between w-full">
                              <p className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                                {m.name}
                              </p>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-shrink-0 border-t border-gray-200 p-4">
                    <Link href="/account" className="group block flex-shrink-0">
                      <div className="flex items-center">
                        <div>
                          <Image
                            className="inline-block h-10 w-10 rounded-full"
                            src={picture}
                            alt=""
                            width={40}
                            height={40}
                            priority={true}
                          />
                        </div>
                        <div className="ml-3">
                          <p className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                            {name}
                          </p>
                          <p className="text-sm font-medium text-gray-500 group-hover:text-gray-700">
                            Account Settings
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
              <div className="w-14 flex-shrink-0" aria-hidden="true">
                {/* Force sidebar to shrink to fit close icon */}
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden lg:flex lg:flex-shrink-0">
          <div className="flex w-16 flex-col">
            <div className="flex min-h-0 flex-1 flex-col bg-navbg">
              <div className="flex flex-col flex-grow">
                <div className="flex items-center justify-center bg-navbg py-3">
                  <div className="h-12 w-auto">
                    <Link href={`/${props.market?.id || ""}`}>
                      <StudioLogo height={"3rem"} />
                    </Link>
                  </div>
                </div>
                <nav
                  aria-label="Sidebar"
                  className="flex flex-col items-center justify-center flex-grow "
                >
                  <div className="flex flex-col items-center space-y-3">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        href={`/${props.market?.id}${item.href}`}
                        className={classNames(
                          "flex items-center p-4 text-navTabIcon hover:bg-navTabActivebg",
                          item.name === props.activeTab
                            ? "bg-navTabActivebg"
                            : "text-navTabIconActive"
                        )}
                      >
                        <item.icon className="h-6 w-6" aria-hidden="true" />
                        <span className="sr-only">{item.name}</span>
                      </Link>
                    ))}
                  </div>
                </nav>
              </div>
              <div className="flex flex-shrink-0 align-middle justify-center py-2">
                <button
                  type="button"
                  className="flex-shrink-0"
                  onClick={() => {
                    // simulate a ctrl + k keypress
                    let event = new KeyboardEvent("keydown", {
                      ctrlKey: true,
                      key: "k",
                    });
                    document.dispatchEvent(event);
                  }}
                >
                  <MagnifyingGlassIcon className="h-6 w-6 text-navTabIconActive"></MagnifyingGlassIcon>
                </button>
              </div>
              <div className="flex flex-shrink-0 align-middle justify-center  py-5">
                <AccountMenu
                  {...props}
                  firstPathLevel={firstPathLevel}
                  martlogo={props.market?.logo}
                  martName={props.market?.name}
                  picture={picture}
                >
                  <>
                    <div className="mx-auto block relative">
                      <Image
                        className="mx-auto block h-10 w-10 rounded-full"
                        src={picture}
                        alt=""
                        width={40}
                        height={40}
                      />

                      {martlogo ? (
                        <Image
                          className="absolute -bottom-1.5 -right-1.5 h-6 w-6 object-cover rounded-full border-navbg/30 border"
                          src={martlogo}
                          alt=""
                          width={40}
                          height={40}
                        />
                      ) : null}
                    </div>

                    <div className="sr-only">
                      <p>{name}</p>
                      <p>Account settings</p>
                    </div>
                  </>
                </AccountMenu>
              </div>
            </div>
          </div>
        </div>

        <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
          {/* Mobile top navigation */}
          <div className="lg:hidden">
            <div className="flex items-center justify-between bg-navbg py-2 px-4 sm:px-6 lg:px-8">
              <div>
                <div className="h-8 w-auto">
                  <StudioLogo height={"2rem"} />
                </div>
              </div>
              <div>
                <button
                  type="button"
                  className="-mr-3 inline-flex h-12 w-12 items-center justify-center rounded-md bg-navbg text-white hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  onClick={() => setMobileMenuOpen(true)}
                >
                  <span className="sr-only">Open sidebar</span>
                  <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>

          <main className="flex flex-1 overflow-hidden">
            <section
              aria-labelledby="primary-heading"
              className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto"
            >
              {props.children}
            </section>
          </main>
        </div>
      </div>
    </>
  );
}

export function AccountMenu(
  props: LayoutProps & {
    firstPathLevel: string;
    martlogo?: string;
    martName?: string;
    picture: string;
  }
) {
  let router = useRouter();

  return (
    <div className="text-right z-20">
      <Menu as="div" className="relative inline-block text-left ">
        <div>
          <Menu.Button className="flex justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            {props.children}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute left-12 bottom-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="flex flex-col justify-center items-center">
              <Image
                src={props.martlogo!}
                className="h-14 w-14 rounded-full mt-6 mb-2"
                width={56}
                height={56}
                alt="Sigs Logo"
              />
              <h4 className="text-center mb-1">{props.martName}</h4>

              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "bg-green-500 text-white" : "text-gray-900"
                    } group flex px-4 justify-center items-center rounded-full py-2 text-sm mb-4`}
                    onClick={() => {
                      router.push(`/${props.market?.id}/settings`);
                    }}
                  >
                    {active ? (
                      <MoveActiveIcon
                        className="mr-2 h-5 w-5"
                        aria-hidden="true"
                      />
                    ) : (
                      <MoveInactiveIcon
                        className="mr-2 h-5 w-5"
                        aria-hidden="true"
                      />
                    )}
                    Market Settings
                  </button>
                )}
              </Menu.Item>
            </div>

            <div className="px-1 py-1 ">
              {(props.markets || []).map((m) => (
                <Menu.Item key={m.id}>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? "bg-green-500 text-white" : "text-gray-900"
                      } group flex w-full items-center justify-start text-left rounded-md px-2 py-2 text-sm`}
                      onClick={() => {
                        router.push(`/${m.id}/${props.firstPathLevel}`);
                      }}
                    >
                      {m.logo ? (
                        <Image
                          className="h-6 w-6 rounded-full mr-2"
                          src={m.logo}
                          width={40}
                          height={40}
                          alt={`${m.name} Logo`}
                        />
                      ) : null}
                      <span className="text-ellipsis overflow-hidden whitespace-nowrap flex-shrink">
                        {m.name}
                      </span>

                      {props.market?.id === m.id ? (
                        <CheckCircleIcon
                          className="ml-auto h-5 w-5 text-green-400"
                          aria-hidden="true"
                        />
                      ) : null}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </div>
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "bg-green-500 text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    onClick={() => {
                      router.push("/account");
                    }}
                  >
                    {active ? (
                      <UserIcon
                        className="mr-2 h-5 w-5 text-green-400"
                        aria-hidden="true"
                      />
                    ) : (
                      <UserIcon
                        className="mr-2 h-5 w-5 text-green-400"
                        aria-hidden="true"
                      />
                    )}
                    {props.session?.name}
                  </button>
                )}
              </Menu.Item>
            </div>
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "bg-green-500 text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    onClick={() => {
                      router.push("/logout");
                    }}
                  >
                    {active ? (
                      <ArrowRightOnRectangleIcon
                        className="mr-2 h-5 w-5 text-green-400"
                        aria-hidden="true"
                      />
                    ) : (
                      <ArrowRightOnRectangleIcon
                        className="mr-2 h-5 w-5 text-green-400"
                        aria-hidden="true"
                      />
                    )}
                    Logout
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}

function EditInactiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 13V16H7L16 7L13 4L4 13Z"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
    </svg>
  );
}

function EditActiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 13V16H7L16 7L13 4L4 13Z"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
    </svg>
  );
}

function DuplicateInactiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H12V12H4V4Z"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <path
        d="M8 8H16V16H8V8Z"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
    </svg>
  );
}

function DuplicateActiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H12V12H4V4Z"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <path
        d="M8 8H16V16H8V8Z"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
    </svg>
  );
}

function ArchiveInactiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="8"
        width="10"
        height="8"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <rect
        x="4"
        y="4"
        width="12"
        height="4"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <path d="M8 12H12" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function ArchiveActiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="8"
        width="10"
        height="8"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <rect
        x="4"
        y="4"
        width="12"
        height="4"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <path d="M8 12H12" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function MoveInactiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 4H16V10" stroke="#A78BFA" strokeWidth="2" />
      <path d="M16 4L8 12" stroke="#A78BFA" strokeWidth="2" />
      <path d="M8 6H4V16H14V12" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function MoveActiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 4H16V10" stroke="#C4B5FD" strokeWidth="2" />
      <path d="M16 4L8 12" stroke="#C4B5FD" strokeWidth="2" />
      <path d="M8 6H4V16H14V12" stroke="#C4B5FD" strokeWidth="2" />
    </svg>
  );
}

function DeleteInactiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="6"
        width="10"
        height="10"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="2"
      />
      <path d="M3 6H17" stroke="#A78BFA" strokeWidth="2" />
      <path d="M8 6V4H12V6" stroke="#A78BFA" strokeWidth="2" />
    </svg>
  );
}

function DeleteActiveIcon(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="6"
        width="10"
        height="10"
        fill="#8B5CF6"
        stroke="#C4B5FD"
        strokeWidth="2"
      />
      <path d="M3 6H17" stroke="#C4B5FD" strokeWidth="2" />
      <path d="M8 6V4H12V6" stroke="#C4B5FD" strokeWidth="2" />
    </svg>
  );
}
